import { createRouter, createWebHistory } from 'vue-router'

import Home from '../views/Home.vue'
import Portefeuille from '../views/Portefeuille.vue'
import Assure from '../views/Assure.vue'
import Search from '../views/Search.vue'
import Extraction from '../views/Extraction.vue'
import Contact from '../views/Contact.vue'
import Docs from '../views/Docs.vue'
import Documents from '../views/Documents.vue'
import Graphique from '../views/Graphique.vue'
import News from '../views/News.vue'
import MentionLegal from '../views/MentionLegal.vue'
import Profil from '../views/Profil.vue'
import Courtiers from '../views/Courtiers.vue'
import SsoAuth from '../views/SsoAuth.vue'

import Login from '../views/Login.vue'

import NotFound from '../views/NotFound.vue'

const routes = [{
        path: '/',
        name: 'home',
        component: Home,
        meta: { requiresAuth: true },
    },
    {
        path: '/portefeuille/:subPage?/:numHolding?/:numEntreprise?/:numContrat?',
        name: 'portefeuille',
        component: Portefeuille,
        meta: { requiresAuth: true },
    },
    {
        path: '/assure/:numSS?',
        name: 'assure',
        component: Assure,
        meta: { requiresAuth: true },
    },
    {
        path: '/search/:holdingIN?/:companyIN?/:numSS?',
        name: 'search',
        component: Search,
        meta: { requiresAuth: true },
    },
    {
        path: '/extraction/:extType?',
        name: 'extraction',
        component: Extraction,
        meta: { requiresAuth: true },
    },
    {
        path: '/contact/',
        name: 'contact',
        component: Contact,
        meta: { requiresAuth: true },
    },
    {
        path: '/docs/:from?/:internal_number?',
        name: 'docs',
        component: Docs,
        meta: { requiresAuth: true },
    },
    {
        path: '/documents',
        name: 'documents',
        component: Documents,
        meta: { requiresAuth: true },
    },
    {
        path: '/courtiers',
        name: 'courtiers',
        component: Courtiers,
        meta: { requiresAuth: true },
    },

    {
        path: '/graphique/:graph/:type/:num',
        name: 'graphique',
        component: Graphique,
        meta: { requiresAuth: true },
    },

    {
        path: '/news/',
        name: 'news',
        component: News,
        meta: { requiresAuth: true },
    },

    {
        path: '/ml',
        name: 'ml',
        component: MentionLegal,
        meta: { requiresAuth: true },
    },
    {
        path: '/profil',
        name: 'profil',
        component: Profil,
        meta: { requiresAuth: true },
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/create_password/:hash',
        name: 'createPassword',
        component: Login
    },
    {
        path: '/login/sso/:access_token',
        name: 'sso',
        component: SsoAuth
    },


    { path: '/:notFound(.*)', component: NotFound }
];




const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach(function(to, _, next) {
    if (to.meta.requiresAuth && !!localStorage.getItem("broker_token") === false) {
        // next('/login');
    } else {
        next();
    }
});

export default router